import { render, staticRenderFns } from "./CampaignMarketing.vue?vue&type=template&id=a23d5e70&lang=pug&"
import script from "./CampaignMarketing.vue?vue&type=script&lang=js&"
export * from "./CampaignMarketing.vue?vue&type=script&lang=js&"
import style0 from "./CampaignMarketing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a23d5e70')) {
      api.createRecord('a23d5e70', component.options)
    } else {
      api.reload('a23d5e70', component.options)
    }
    module.hot.accept("./CampaignMarketing.vue?vue&type=template&id=a23d5e70&lang=pug&", function () {
      api.rerender('a23d5e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/campaigns/CampaignMarketing/CampaignMarketing.vue"
export default component.exports